import { CloudPlatform } from '@/pages/admin/settings/cloud_provider/CloudProviderCategory';

export const NO_CP_MANAGE_PERMISSION_MESSAGE = 'You do not have permission to create or delete cloud providers.';

export function isCPDisabled(status: string) {
  return !['active', 'upgradecomplete', 'upgrading'].includes(status);
}

// `platform` casing is inconsistent across APIs ('GCP' vs 'gcp'), so compare case-insensitively.
export function isGCPPlatform(platform?: string) {
  return platform?.toUpperCase() === CloudPlatform.GCP;
}
